import axios from 'axios';

// API base must end with /api (e.g. https://talsolution.com/api). FRONTEND_URL is the site URL, not the API.
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined' && window.location?.hostname !== 'localhost' && window.location?.hostname !== '127.0.0.1') {
    return `${window.location.origin}/api`;
  }
  return 'http://localhost:3001/api';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Position APIs
export const positionAPI = {
    getAll: (params) => api.get('/positions', { params }),
    getById: (id) => api.get(`/positions/${id}`),
    getFilters: () => api.get('/positions/meta/filters'),
};

// Application APIs
export const applicationAPI = {
    submit: (formData) => {
        return api.post('/applications', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    getByPosition: (positionId) => api.get(`/applications/position/${positionId}`),
    getById: (id) => api.get(`/applications/${id}`),
    markAsSeen: (id) => api.patch(`/applications/${id}/seen`),
};

// Auth APIs
export const authAPI = {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    getMe: () => {
        const token = localStorage.getItem('talsolution_token');
        return api.get('/auth/me', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    },
    verifyEmail: (token) => api.get(`/auth/verify-email?token=${token}`),
    resendVerification: (email) => api.post('/auth/resend-verification', { email }),
    forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
    resetPassword: (token, password) => api.post('/auth/reset-password', { token, password }),
};

// Profile APIs
export const profileAPI = {
    getProfile: () => api.get('/profile/me'),
    updateProfile: (data) => api.put('/profile/me', data),
    uploadResume: (file) => {
        const formData = new FormData();
        formData.append('resume', file);
        return api.post('/profile/me/resume', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    uploadAvatar: (file) => {
        const formData = new FormData();
        formData.append('avatar', file);
        return api.post('/profile/me/avatar', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getApplications: () => api.get('/profile/me/applications'),
};

// Add request interceptor to include token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('talsolution_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid
            localStorage.removeItem('talsolution_token');
            localStorage.removeItem('talsolution_user');
            localStorage.removeItem('talsolution_token_timestamp');
            // Redirect to login if not already there
            if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
